import styled from "styled-components"
import BandeauGDD from "../../../assets/bandeau_guide_v1.svg"

const StyledSection = styled.section`
  & a {
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
  & button {
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
  & h2 {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
  & h3 {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

const BandeauStyled = styled(BandeauGDD)`
  width: 80%;
  display: block;
  margin: 0 5rem 0 0;
  & .st4 {
    fill: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  @media (max-width: 1400px) {
    margin: 0 5rem 0 0;
  }
  @media (max-width: 600px) {
    width: 65%;
    margin: 0 0 2rem 0;
    transform: scale(1.75);
  }
`

export { StyledSection, BandeauStyled }
